import type { HiredEquipmentAnchor } from '../types';
import { HIRED_EQUIPMENT_ENTRY_METHODS } from '../types';

const STORAGE_KEY = 'wrap.hiredEquipment.anchor';

function isEntryMethod(value: unknown): value is HiredEquipmentAnchor['entryMethod'] {
  return (
    typeof value === 'string' &&
    (HIRED_EQUIPMENT_ENTRY_METHODS as readonly string[]).includes(value)
  );
}

export function persistHiredEquipmentAnchor(anchor: HiredEquipmentAnchor): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(anchor));
  } catch {
    // Private mode / quota — location.state is the primary handoff.
  }
}

export function readHiredEquipmentAnchor(): HiredEquipmentAnchor | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    const candidate = parsed as Partial<HiredEquipmentAnchor>;
    if (!isEntryMethod(candidate.entryMethod)) return null;
    return candidate as HiredEquipmentAnchor;
  } catch {
    return null;
  }
}

export function clearHiredEquipmentAnchor(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
